(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["employee-overlay"] && !Shopify.designMode) return;
  try {
    (() => {
  'use strict';
  const config = document.querySelector('[data-washburns-employee]');
  if (!config || config.dataset.started || !['https://washburns.com','https://www.washburns.com'].includes(location.origin) || window.top !== window) return;
  config.dataset.started = 'true';
  const portal = 'https://employees.washburns.com', namespace = 'washburns-employee-v1';
  const frames = {}, boxes = {};
  let barActive = false, productActive = false, productFrameCreated = false, permanentlyLocked = false;
  let lastSelection = null, lastSku = null, variants = [];
  try { variants = JSON.parse(config.dataset.variants || '[]'); } catch {}
  const variantsById = new Map(variants.filter(v => v && typeof v === 'object').map(v => [String(v.id), {
    sku: typeof v.sku === 'string' ? v.sku.trim() : '',
    priceCents: Number.isSafeInteger(v.price) ? v.price : null
  }]));
  const send = (view, type, extra = {}) => frames[view]?.contentWindow?.postMessage({ namespace, type, ...extra }, portal);
  const spacer = document.createElement('div'); spacer.id = 'wb-employee-spacer'; spacer.hidden = true; config.after(spacer);
  function renderVisibility() {
    boxes.bar.hidden = !barActive; spacer.hidden = !barActive;
    document.documentElement.classList.toggle('wb-employee-on', barActive);
    if (boxes.product) boxes.product.hidden = !(barActive && productActive);
    window.dispatchEvent(new Event('scroll'));
  }
  function frame(view) {
    const box = document.createElement('div'); box.id = 'wb-employee-' + view; box.hidden = true;
    const f = document.createElement('iframe');
    f.title = view === 'bar' ? 'Washburns employee tools' : 'Washburns private product details';
    f.setAttribute('sandbox', 'allow-scripts allow-same-origin allow-top-navigation-by-user-activation');
    f.referrerPolicy = 'no-referrer';
    f.src = portal + '/api/storefront/frame?view=' + view + '&parent=' + encodeURIComponent(location.origin);
    f.height = view === 'bar' ? '34' : '46'; f.setAttribute('scrolling', view === 'bar' ? 'no' : 'auto');
    box.append(f); frames[view] = f; boxes[view] = box;
    if (view === 'bar') document.body.append(box);
    else {
      const main = document.getElementById('main-content') || document.querySelector('main');
      const description = main?.querySelector('.product-information .product--short-description, .product-information--under-gallery .product--short-description, .hp__overview');
      const productSlot = main?.querySelector('[data-wb-employee-product-slot]');
      if (productSlot) productSlot.append(box);
      else if (description) description.before(box);
      else {
        const target = main?.querySelector('.product-information') || main;
        if (target) { if (target === main) { box.classList.add('wb-employee-wide'); target.prepend(box); } else target.append(box); }
      }
    }
  }
  function productContext(force = false) {
    if (!frames.product || !barActive || permanentlyLocked) return;
    const main = document.getElementById('main-content') || document.querySelector('main');
    const scope = main?.querySelector('.product-information') || main;
    const input = scope?.querySelector('form[action*="/cart/add"] [name="id"]');
    const param = new URLSearchParams(location.search).get('variant');
    const id = input ? (input.disabled ? '' : String(input.value || '')) : (param || config.dataset.variant || '');
    const variant = variantsById.get(id);
    const sku = variant?.sku || '', selection = id || 'unselected';
    const priceCents = variant?.priceCents ?? null;
    const sameCurrency = config.dataset.storeCurrency === config.dataset.presentmentCurrency;
    if (force || selection !== lastSelection || sku !== lastSku) {
      lastSelection = selection; lastSku = sku;
      send('product', 'context', { sku: sku.slice(0, 200), selection: selection.slice(0, 100), priceCents, sameCurrency });
    }
  }
  window.addEventListener('message', event => {
    if (event.origin !== portal || event.data?.namespace !== namespace) return;
    const view = Object.keys(frames).find(key => frames[key].contentWindow === event.source);
    if (!view || event.data.view !== view) return;
    const data = event.data;
    if (data.type === 'ready') { if (view === 'product') productContext(true); return; }
    if (data.type === 'lock' && view === 'bar') {
      permanentlyLocked = true; productActive = false; send('product', 'lock'); renderVisibility(); return;
    }
    if (data.type === 'recheck') { send('bar', 'recheck'); return; }
    if (data.type !== 'visibility' || typeof data.active !== 'boolean' || typeof data.height !== 'number' || !Number.isFinite(data.height)) return;
    if (view === 'bar') {
      const wasActive = barActive; barActive = data.active;
      if (!barActive) { productActive = false; send('product', 'suspend'); }
      if (barActive && !wasActive) send('product', 'recheck');
      if (barActive && config.dataset.product === 'true' && !productFrameCreated && !permanentlyLocked) {
        productFrameCreated = true; frame('product');
      }
    } else productActive = data.active && !permanentlyLocked;
    frames[view].style.height = (view === 'bar' ? 34 : Math.min(16000, Math.max(46, Math.ceil(data.height)))) + 'px';
    renderVisibility(); if (view === 'bar' && barActive) productContext(true);
  });
  frame('bar');
  const recheck = () => { if (!permanentlyLocked) { send('bar','recheck'); send('product','recheck'); productContext(true); } };
  window.addEventListener('focus', recheck); window.addEventListener('pageshow', recheck);
  window.addEventListener('pagehide', () => { barActive = false; productActive = false; renderVisibility(); });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') recheck();
    else { barActive = false; productActive = false; renderVisibility(); send('product','suspend'); }
  });
  window.addEventListener('popstate', () => productContext());
  document.addEventListener('change', event => {
    if (!barActive || !frames.product || !event.target.closest?.('#main-content,main')) return;
    queueMicrotask(() => productContext()); setTimeout(() => productContext(), 250);
  });
  for (const name of ['variant:change','variant:changed','product:variant-change']) document.addEventListener(name, () => productContext());
  setInterval(() => { if (barActive && document.visibilityState === 'visible') productContext(); }, 400);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["wb-appliance-product-layout"] && !Shopify.designMode) return;
  try {
    (() => {
  const mount = root => {
    if (root.dataset.wbMounted) return;
    root.dataset.wbMounted = 'true';
    const sectionId = root.dataset.section;
    const form = document.getElementById(`product-form-${sectionId}`);
    const primary = form?.querySelector('button[name="add"]');
    const bar = root.querySelector('[data-wb-purchase-bar]');
    const sticky = root.querySelector('[data-wb-sticky-button]');
    const mainPrice = document.getElementById(`price-${sectionId}`);
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const abort = new AbortController();
    const observers = [];
    const floatingOffsets = new Map();
    const widgetDock = document.createElement('div');
    widgetDock.className = 'wb-mobile-widget-dock';
    root.querySelector('.wb-product-details')?.after(widgetDock);
    const mobile = window.matchMedia('(max-width:600px)');
    const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency',currency:root.dataset.wbCurrency || 'USD'}).format(cents / 100);
    let unitPrice = Number(root.dataset.wbPrice);
    let frame = 0;
    let hasSeenPurchase = false;
    let disposed = false;
    const listen = (node, name, fn, extra = {}) => node?.addEventListener(name, fn, {...extra, signal: abort.signal});
    const goTo = target => {
      if (!target) return;
      for (let parent = target; parent && parent !== root; parent = parent.parentElement) {
        if (parent.tagName === 'DETAILS') parent.open = true;
      }
      target.scrollIntoView({behavior: reducedMotion.matches ? 'auto' : 'smooth', block:'start'});
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex','-1');
      target.focus({preventScroll:true});
    };
    const update = () => {
      frame = 0;
      if (!root.isConnected) return;
      const header = document.getElementById('header');
      const headerShell = header?.closest('.header-section') || header;
      const headerRect = headerShell?.getBoundingClientRect();
      const headerStyle = headerShell ? getComputedStyle(headerShell).position : '';
      const headerBottom = headerRect && ['sticky','fixed'].includes(headerStyle) ? Math.max(0,headerRect.bottom) : 0;
      const employeeBar = document.getElementById('wb-employee-bar');
      const employeeOffset = Math.max(0, employeeBar?.getBoundingClientRect().bottom || 0);
      root.closest('.shopify-section')?.querySelector('.pswp')?.style.setProperty('--wb-employee-offset', `${Math.round(employeeOffset)}px`);
      const offset = Math.max(headerBottom, employeeOffset);
      root.style.setProperty('--wb-header-offset', `${Math.round(offset)}px`);
      if (!primary || !bar || !sticky) return;
      const rect = primary.getBoundingClientRect();
      const visible = rect.bottom > offset && rect.top < window.innerHeight;
      if (visible) hasSeenPurchase = true;
      const pageRect = root.getBoundingClientRect();
      const footer = document.getElementById('footer')?.getBoundingClientRect();
      const suppress = document.querySelector('dialog[open], .side-panel.active, .side-panel.is-active, .pswp--open, .messenger-chat-widget.active, cart-drawer:not([inert]), #header .mobile-toggle-wrapper[open]');
      bar.hidden = visible || pageRect.top > offset + 120 || Boolean(footer && footer.top < window.innerHeight - 80) || Boolean(suppress);
      document.querySelectorAll('#assistantPopup, .group-position-container').forEach(widget => {
        if (!floatingOffsets.has(widget)) {
          const host = widget.closest('.omega-chat-root') || widget;
          const marker = document.createElement('span');
          marker.hidden = true;
          host.before(marker);
          floatingOffsets.set(widget, {value:widget.style.getPropertyValue('bottom'),priority:widget.style.getPropertyPriority('bottom'),marker,host,offsetApplied:false,baselineBottom:parseFloat(getComputedStyle(widget).bottom)||0});
          const observer = new MutationObserver(queue);
          observer.observe(widget,{attributes:true,subtree:true,attributeFilter:['style','class']});observers.push(observer);
        }
        const original = floatingOffsets.get(widget);
        const expanded = widget.id === 'assistantPopup' ? widget.getBoundingClientRect().height > 160 : Boolean(widget.querySelector('.messenger-chat-widget.active'));
        if (mobile.matches || !expanded) {
          if (original.host.parentElement !== widgetDock) widgetDock.append(original.host);
          if (expanded) delete widget.dataset.wbDocked; else widget.dataset.wbDocked = 'true';
        } else {
          if (original.host.parentElement === widgetDock) original.marker.after(original.host);
          delete widget.dataset.wbDocked;
        }
        if (mobile.matches || !expanded) {
          if (original.offsetApplied) {
            if (original.value) widget.style.setProperty('bottom',original.value,original.priority); else widget.style.removeProperty('bottom');
            original.offsetApplied = false;
          }
        } else {
          const widgetRect = widget.getBoundingClientRect();
          const naturalBottom = window.innerHeight - original.baselineBottom;
          const coversPurchase = visible && widgetRect.right > rect.left && widgetRect.left < rect.right && naturalBottom > rect.top && naturalBottom - widgetRect.height < rect.bottom;
          const value = bar.hidden ? (coversPurchase ? `${Math.max(16,window.innerHeight - rect.top + 16)}px` : original.value) : `${bar.offsetHeight + 16}px`;
          const priority = bar.hidden && !coversPurchase ? original.priority : 'important';
          if (widget.style.getPropertyValue('bottom') !== value || widget.style.getPropertyPriority('bottom') !== priority) {
            if (value) widget.style.setProperty('bottom',value,priority); else widget.style.removeProperty('bottom');
          }
          original.offsetApplied = !bar.hidden || coversPurchase;
        }
        if (mobile.matches && expanded) bar.hidden = true;
      });
      const dockRect = widgetDock.getBoundingClientRect();
      if (mobile.matches && widgetDock.childElementCount && dockRect.top < window.innerHeight && dockRect.bottom > offset) bar.hidden = true;
      const chooseFirst = false;
      const sourceLabel = primary.querySelector('.single-add-to-cart-button--text')?.textContent.trim() || primary.textContent.trim();
      const busy = primary.disabled || primary.classList.contains('loading') || primary.getAttribute('aria-disabled') === 'true';
      const desired = chooseFirst ? root.dataset.chooseLabel : sourceLabel;
      if (sticky.textContent.trim() !== desired) sticky.textContent = desired;
      sticky.disabled = chooseFirst ? false : busy;
      sticky.dataset.choose = String(chooseFirst);
      const quantity = Math.max(1, Number(form.querySelector('[name="quantity"]')?.value) || 1);
      const picker = root.querySelector('wb-addon-picker');
      const selected = picker?.selectedRows?.() || [];
      const addonCents = selected.reduce((sum,row) => sum + row.variant.price * row.quantity * (row.kind === 'haul' ? 1 : quantity), 0);
      root.querySelector('[data-wb-sticky-price]').textContent = money(unitPrice * quantity + addonCents);
      const addonTotal = picker?.querySelector('.wb-addon-total:not([hidden])');
      const extras = root.querySelector('[data-wb-sticky-extras]');
      const detail = addonTotal ? [...addonTotal.children].map(node => node.textContent.trim()).join(' ') : '';
      if (extras) extras.textContent = [quantity > 1 ? `${quantity} × ${money(unitPrice)}` : '', detail].filter(Boolean).join(' \u00b7 ');
    };
    const queue = () => { if (!frame && !disposed) frame = requestAnimationFrame(update); };
    const floatingObserver = new MutationObserver(queue);
    floatingObserver.observe(document.body,{childList:true});observers.push(floatingObserver);
    const overlayObserver = new MutationObserver(queue);
    document.querySelectorAll('.pswp, .side-panel, dialog, [role=dialog], cart-drawer, #header .mobile-toggle-wrapper').forEach(overlay => overlayObserver.observe(overlay,{attributes:true,attributeFilter:['class','open','inert']}));
    observers.push(overlayObserver);
    listen(window,'scroll',queue,{passive:true});
    listen(window,'resize',queue,{passive:true});
    listen(root,'change',queue);
    listen(root,'input',queue);
    listen(root,'wb:change',queue);
    listen(root,'wb:selection-updated',queue);
    listen(document,'product:variant-change',event => {
      if (String(event.detail?.sectionId) !== String(sectionId)) return;
      if (event.detail?.variant) unitPrice = Number(event.detail.variant.price);
      const installment = document.getElementById(`product-form-installment-${sectionId}`);
      const input = installment?.querySelector('[name="id"]');
      if (input && event.detail?.variant) {
        input.value = event.detail.variant.id;
        input.dispatchEvent(new Event('change',{bubbles:true}));
      }
      queue();
    });
    listen(sticky,'click',() => {
      if (sticky.dataset.choose === 'true') { goTo(root.querySelector(`#wb-purchase-${CSS.escape(sectionId)}`)); return; }
      if (!primary.disabled && primary.getAttribute('aria-disabled') !== 'true') primary.click();
      queue();
    });
    root.querySelectorAll('[data-wb-options-link]').forEach(link => listen(link,'click',event => {event.preventDefault();goTo(root.querySelector(`#wb-purchase-${CSS.escape(sectionId)}`));}));
    if (primary) {
      const watch = new MutationObserver(queue);
      watch.observe(primary,{attributes:true,childList:true,subtree:true});
      if (mainPrice) watch.observe(mainPrice,{childList:true,subtree:true});
      const picker = root.querySelector('wb-addon-picker');
      if (picker) watch.observe(picker,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden']});
      observers.push(watch);
      const visibility = new IntersectionObserver(queue,{threshold:[0,1]});
      visibility.observe(primary);observers.push(visibility);
      const error = form.closest('product-form')?.querySelector('.product-form__error-message-wrapper');
      if (error) {
        const errorObserver = new MutationObserver(() => {if (!error.hidden && error.textContent.trim()) goTo(form);});
        errorObserver.observe(error,{attributes:true,childList:true,subtree:true});observers.push(errorObserver);
      }
    }
    const description = root.querySelector('.wb-description');
    const normalized = text => text.replace(/\s+/g,' ').trim();
    const specRows = [...(description?.querySelectorAll('tr') || [])].filter(row => row.cells.length === 2).map(row => ({label:normalized(row.cells[0].textContent),value:normalized(row.cells[1].textContent)}));
    const dimensions = ['Width','Height','Depth'].map(dimension => {
      const candidates = specRows.filter(row => {const label=row.label.toLowerCase().replace(/^overall /,'');const name=dimension.toLowerCase();return label===name || label.startsWith(name+' (') || label.startsWith(name+' including') || label.startsWith(name+' with') || label.startsWith(name+' without');});
      const row = candidates.find(item => /including handles/i.test(item.label)) || candidates.find(item => /^overall/i.test(item.label)) || candidates.find(item => !/without/i.test(item.label));
      return row ? {label:row.label,value:row.value} : null;
    }).filter(Boolean);
    const fit = root.querySelector('[data-wb-fit]');
    if (fit && dimensions.length === 3) {
      const dl = fit.querySelector('dl');
      dimensions.forEach(dimension => {const item=document.createElement('div');const term=document.createElement('dt');term.textContent=dimension.label.replace(/^overall /i,'');const value=document.createElement('dd');value.textContent=dimension.value;item.append(term,value);dl.append(item);});
      fit.hidden=false;
    }
    const finish = specRows.find(row => ['color','finish','color/finish','color / finish'].includes(row.label.toLowerCase()));
    const caption = root.querySelector('[data-wb-finish]');
    if (finish && caption) {caption.textContent=finish.value;caption.hidden=false;}
    const docLinks = [...(description?.querySelectorAll('a[href]') || [])].filter(link => /\.pdf(?:$|[?#])/i.test(link.href));
    const docList = root.querySelector('[data-wb-document-list]');
    const seen = new Set();
    docLinks.forEach(link => {if(seen.has(link.href))return;seen.add(link.href);const copy=link.cloneNode(true);copy.removeAttribute('style');copy.textContent=copy.textContent.trim().replace(/\s*↗+\s*$/,'');copy.target='_blank';copy.rel='noopener';docList?.append(copy);});
    if (docList && docList.childElementCount) docList.hidden=false;
    const tables = [...(description?.querySelectorAll('table') || [])];
    tables.forEach((table,index) => {
      const wrap = document.createElement('div');wrap.className = 'wb-table-scroll';wrap.tabIndex = 0;
      wrap.setAttribute('role','region');wrap.setAttribute('aria-label',root.dataset.tableLabel);
      wrap.id = `wb-spec-${sectionId}-${index}`;
      table.before(wrap);wrap.append(table);
      const wide = [...table.rows].some(row => [...row.cells].reduce((sum,cell)=>sum+cell.colSpan,0)>2);
      if (wide) {
        wrap.classList.add('wb-wide-table');
        const hint = document.createElement('p');hint.className='wb-table-hint';hint.textContent=root.dataset.tableHint;wrap.before(hint);
      }
      if (!table.caption) {const caption=table.createCaption();caption.className='wb-visually-hidden';caption.textContent=root.dataset.tableLabel;}
      if (!wide) [...table.rows].forEach(row => {
        if (row.cells.length !== 2 || row.cells[0].colSpan !== 1 || row.cells[0].rowSpan !== 1 || row.closest('thead')) return;
        if (row.cells[0].tagName === 'TH') {row.cells[0].scope='row';return;}
        const cell=row.cells[0],heading=document.createElement('th');heading.scope='row';heading.append(...cell.childNodes);cell.replaceWith(heading);
      });
    });
    const connectJump = (selector,target) => {
      const link=root.querySelector(selector);if (!link || !target) return;
      link.hidden=false;link.href=`#${target.id}`;
      listen(link,'click',event=>{event.preventDefault();goTo(target);});
    };
    connectJump('[data-wb-spec-link]',root.querySelector('.wb-table-scroll'));
    connectJump('[data-wb-fit-guide]',root.querySelector('.wb-table-scroll'));
    root.querySelectorAll('.wb-details-nav a').forEach(link=>listen(link,'click',()=>{root.querySelectorAll('.wb-details-nav a').forEach(item=>item.classList.toggle('is-active',item===link));}));
    const headings=[...(description?.querySelectorAll('h2,h3,h4,summary') || [])];
    const documents=headings.find(heading=>/manual|document|download|guide/i.test(heading.textContent));
    if (documents) {documents.id ||= `wb-documents-${sectionId}`;connectJump('[data-wb-document-link]',documents);}
    const picker=root.querySelector('wb-addon-picker');
    const compactPicker=()=>{
      const note=picker?.querySelector('.wb-addon-service-note');
      if (note && !note.closest('details')) {
        const details=document.createElement('details');details.className='wb-addon-service-details';
        const summary=document.createElement('summary');summary.textContent=root.dataset.addonDetails;
        note.before(details);details.append(summary,note);
      }
    };
    if (picker) {const observer=new MutationObserver(compactPicker);observer.observe(picker,{childList:true,subtree:true});observers.push(observer);compactPicker();}
    const slider=root.querySelector('product-slider');
    listen(root,'keydown',event=>{
      const arrow=event.target.closest('.flickity-nav');
      if(!arrow || !['Enter',' '].includes(event.key))return;
      event.preventDefault();event.stopImmediatePropagation();arrow.click();
    },{capture:true});
    listen(root,'keyup',event=>{
      if(!event.target.closest('.flickity-nav'))return;
      event.stopImmediatePropagation();
      if(['Enter',' '].includes(event.key))event.preventDefault();
    },{capture:true});
    const syncGallery=()=>{
      const thumbs=[...root.querySelectorAll('.product-thumbnail')];
      const visibleThumbs=thumbs.filter(thumb=>getComputedStyle(thumb).display!=='none');
      const active=Math.max(0,visibleThumbs.findIndex(thumb=>thumb.classList.contains('is-initial-selected')));
      thumbs.forEach((thumb,index)=>{
        thumb.setAttribute('role','button');thumb.tabIndex=getComputedStyle(thumb).display==='none'?-1:0;
        thumb.setAttribute('aria-label',`${root.dataset.imageLabel} ${index+1}`);
        thumb.setAttribute('aria-pressed',String(thumb===visibleThumbs[active]));
      });
      const count=root.querySelector('[data-wb-image-count]');
      if(count && visibleThumbs.length) count.textContent=`${Math.max(1,active+1)} / ${visibleThumbs.length}`;
    };
    root.querySelectorAll('.product-thumbnail').forEach(thumb=>listen(thumb,'keydown',event=>{if(event.key==='Enter'||event.key===' '){event.preventDefault();thumb.click();}}));
    root.querySelectorAll('.product-single__media-zoom').forEach((zoom,index)=>{zoom.tabIndex=0;zoom.setAttribute('aria-label',`${root.dataset.zoomLabel} ${index+1}`);});
    const thumbContainer=root.querySelector('.product-thumbnail-container');
    if(thumbContainer){const observer=new MutationObserver(syncGallery);observer.observe(thumbContainer,{subtree:true,attributes:true,attributeFilter:['class']});observers.push(observer);syncGallery();}
    if(slider) {
      listen(slider,'keydown',event=>{
        if(event.target.closest('button,a,video,iframe'))return;
        if(event.key==='ArrowLeft'){event.preventDefault();slider.flkty?.previous();}
        if(event.key==='ArrowRight'){event.preventDefault();slider.flkty?.next();}
      });
    }
    listen(document,'shopify:section:unload',event=>{
      if(event.detail?.sectionId !== sectionId)return;
      disposed=true;abort.abort();observers.forEach(observer=>observer.disconnect());if(frame)cancelAnimationFrame(frame);
      floatingOffsets.forEach((original,widget)=>{original.marker.after(original.host);original.marker.remove();delete widget.dataset.wbDocked;if(original.offsetApplied){if(original.value)widget.style.setProperty('bottom',original.value,original.priority);else widget.style.removeProperty('bottom');}});
      widgetDock.remove();
    });
    update();
  };
  const init=scope=>scope.querySelectorAll('.wb-pdp').forEach(mount);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
  document.addEventListener('shopify:section:load',event=>init(event.target));
})();
  } catch(e) { console.error(e); }
})();

})();
